import React, { useState, Fragment } from 'react';
import { CheckIcon } from 'lucide-react';
import BusinessInfoStep from '../components/onboarding/BusinessInfoStep';
import AccountInfoStep from '../components/onboarding/AccountInfoStep';
import PartnerInfoStep from '../components/onboarding/PartnerInfoStep';
import DocumentUploadStep from '../components/onboarding/DocumentUploadStep';
import ComplianceScreeningStep from '../components/onboarding/ComplianceScreeningStep';
const steps = [{
  id: 1,
  name: 'Business Info'
}, {
  id: 2,
  name: 'Account Info'
}, {
  id: 3,
  name: 'Partner Info'
}, {
  id: 4,
  name: 'Documents'
}, {
  id: 5,
  name: 'Compliance'
}];
const OnboardingPage = () => {
  const [currentStep, setCurrentStep] = useState(1);
  const [formData, setFormData] = useState({
    businessInfo: {},
    accountInfo: {},
    partnerInfo: {},
    documents: {},
    compliance: {}
  });
  const updateFormData = (step: string, data: any) => {
    setFormData(prev => ({
      ...prev,
      [step]: data
    }));
  };
  const nextStep = () => {
    if (currentStep < steps.length) {
      setCurrentStep(currentStep + 1);
    }
  };
  const prevStep = () => {
    if (currentStep > 1) {
      setCurrentStep(currentStep - 1);
    }
  };
  const renderStep = () => {
    switch (currentStep) {
      case 1:
        return <BusinessInfoStep data={formData.businessInfo} updateData={data => updateFormData('businessInfo', data)} onNext={nextStep} data-id="element-1537" />;
      case 2:
        return <AccountInfoStep data={formData.accountInfo} updateData={data => updateFormData('accountInfo', data)} onNext={nextStep} onBack={prevStep} data-id="element-1538" />;
      case 3:
        return <PartnerInfoStep data={formData.partnerInfo} updateData={data => updateFormData('partnerInfo', data)} onNext={nextStep} onBack={prevStep} data-id="element-1539" />;
      case 4:
        return <DocumentUploadStep data={formData.documents} updateData={data => updateFormData('documents', data)} onNext={nextStep} onBack={prevStep} data-id="element-1540" />;
      case 5:
        return <ComplianceScreeningStep data={formData.compliance} updateData={data => updateFormData('compliance', data)} onBack={prevStep} formData={formData} data-id="element-1541" />;
      default:
        return null;
    }
  };
  return <div className="min-h-screen bg-[#F8FAFC] py-8 px-4" data-id="element-1542">
      <div className="max-w-4xl mx-auto" data-id="element-1543">
        {/* Header with Paysys Logo */}
        <div className="text-center mb-8" data-id="element-1544">
          <img src="https://cdn.magicpatterns.com/uploads/ca1Sgnsnn3Rh2VWwbyfsy6/Paysys_Logo.png" alt="Paysys" className="h-10 mx-auto mb-6" data-id="element-1545" />
          <h1 className="text-3xl font-bold text-[#0D3B66]" data-id="element-1546">
            Merchant Onboarding
          </h1>
          <p className="text-gray-600 mt-2" data-id="element-1547">
            Complete the following steps to set up your merchant account
          </p>
        </div>

        {/* Progress Steps */}
        <div className="mb-10" data-id="element-1548">
          <div className="flex items-center justify-between" data-id="element-1549">
            {steps.map((step, index) => <Fragment key={step.id} data-id="element-1550">
                <div className="flex flex-col items-center" data-id="element-1551">
                  <div className={`w-10 h-10 rounded-full flex items-center justify-center font-semibold transition-all ${step.id < currentStep ? 'bg-[#0D3B66] text-white' : step.id === currentStep ? 'bg-[#F5A623] text-[#0D3B66] ring-4 ring-[#F5A623]/30' : 'bg-gray-200 text-gray-500'}`} data-id="element-1552">
                    {step.id < currentStep ? <CheckIcon className="h-5 w-5" data-id="element-1553" /> : step.id}
                  </div>
                  <span className={`mt-2 text-xs font-medium hidden sm:block ${step.id === currentStep ? 'text-[#0D3B66]' : 'text-gray-500'}`} data-id="element-1554">
                    {step.name}
                  </span>
                </div>
                {index < steps.length - 1 && <div className={`flex-1 h-1 mx-2 rounded ${step.id < currentStep ? 'bg-[#0D3B66]' : 'bg-gray-200'}`} data-id="element-1555" />}
              </Fragment>)}
          </div>
        </div>

        {/* Step Content */}
        <div className="bg-white rounded-xl shadow-sm border border-[#E2E8F0] p-6 md:p-8" data-id="element-1556">
          {renderStep()}
        </div>
      </div>
    </div>;
};
export default OnboardingPage;